import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import {
  Wrapper,
  Header,
  NumberWrapper,
  ActivityBubbles,
  StatsContainer,
} from './elements';
import ActivitiesList from './ActivitiesList';
import Lab115B from 'dc/Lab115B';
import { useText, useFormatNumber, useGetActivityIconUrl } from 'common/hooks';

type Props = {
  readonly totalLoggedActivities: number;
};

const deps = {
  activities: state.appContainer.activities,
  organisationName: state.challenge.campaign.organisation.name,
  activitiesCount: state.challenge.stats.total.challenge.activitiesCount,
};

export function ActivitiesInsights({
  activities,
  organisationName,
  activitiesCount,
  totalLoggedActivities,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const formatNumber = useFormatNumber();
  const getActivityIconUrl = useGetActivityIconUrl();

  function getActivityBubbles() {
    return Object.keys(activitiesCount).reduce((allActivities, activityKey) => {
      const activity = activities[activityKey];

      if (!activity) return allActivities;

      const icon = getActivityIconUrl(activity?.icon);
      const size = activitiesCount[activityKey];

      allActivities.push({
        icon: icon,
        size: size,
        text: activity.title,
      });

      return allActivities;
    }, []);
  }

  if (totalLoggedActivities === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Header
        title={t('challenge.ChaPaD24B.ChaStat4D.registered_activities', {
          organisationName,
        })}
      />
      <NumberWrapper>
        <Lab115B
          icon={'icon-check_circle'}
          label={t('challenge.ChaPaD24B.ChaStat4D.activities')}
          value={formatNumber(totalLoggedActivities)}
        />
      </NumberWrapper>
      <StatsContainer>
        <ActivityBubbles
          header_text={t('challenge.ChStPrt7.most_popular_activity')}
          unit_text={t('challenge.ChStPrt7.activities')}
          activityBubbles={getActivityBubbles()}
        />
        <ActivitiesList totalLoggedActivities={totalLoggedActivities} />
      </StatsContainer>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, ActivitiesInsights);
